import * as React from 'react';
import { CianLogo } from '../../../components/Icons';
import * as styles from './CianInfo.css';

export function CianInfo() {
  return (
    <div className={styles['container']}>
      <div className={styles['logo']}>
        <CianLogo />
      </div>
      <div className={styles['consultant_label']}>Консультант</div>
      <div className={styles['text']}>Циан</div>
    </div>
  );
}
